import { debounce, scrollToSection } from 'ui-helpers';
import PayPal from 'vendors/paypal';

const addPayPalMarketingBanner = (update) => {
  if (typeof window !== 'undefined') {
    let amount = 0;
    try {
      amount = parseFloat(document.querySelector('.gcc-prd-prcupd-prc-curr').textContent.replace(/[^0-9.]/g, ''));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(`PayPal Marketing Banner: Amount on the PIP couldn't be parsed: ${e}`);
    }
    const paypal = new PayPal();
    const options = {
      amount,
      style: {
        layout: 'text',
        logo: {
          position: 'left',
          type: 'alternative',
        },
      },
    };
    if (update) {
      paypal.updateMarketingBanner('#gcc-prd-ppcredit', options);
    } else {
      paypal.addMarketingBanner('#gcc-prd-ppcredit', options);
    }
  }
};

const sendAnalytics = (tabName) => {
  // eslint-disable-next-line no-underscore-dangle, no-undef
  if (window._T && typeof _T.sendEventDataToAnalytics !== 'undefined') {
    const thdAnalyticsEvent = {
      category: {
        primaryCategory: 'button submission',
      },
      eventInfo: {
        eventName: 'flex button',
        eventDescription: tabName,
      },
    };
    // eslint-disable-next-line no-undef
    if (_T.sendEventDataToAnalytics) {
      // eslint-disable-next-line no-undef
      _T.sendEventDataToAnalytics(thdAnalyticsEvent);
    }
  }
};

const handleTabClicks = () => {
  const tabButtons = document.querySelectorAll('#Tabs button');
  Array.prototype.forEach.call(tabButtons, (navItem) => {
    navItem.addEventListener('click', (e) => {
      Array.prototype.forEach.call(tabButtons, (b) => {
        b.classList.remove('active');
      });
      const { target } = e;
      target.classList.add('active');
      const activeTab = target.attributes.title.value;

      // show content block
      document.querySelector('main.gcc-prd').dataset.tab = activeTab;
      scrollToSection('#scrollHere', 20);

      if (activeTab === 'colors-tab') {
        sendAnalytics('tabs - product colors');
      } else if (activeTab === 'reviews-tab') {
        sendAnalytics('tabs - product revivews');
      } else if (activeTab === 'qa-tab') {
        sendAnalytics('tabs - question & answers');
      } else if (activeTab === 'details-tab') {
        sendAnalytics('tabs - product details');
      }
    });
  });
};

handleTabClicks();
addPayPalMarketingBanner();
const observer = new MutationObserver((mutations) =>
  mutations.forEach((mutation) => {
    if (mutation.attributeName === 'data-current-price') {
      debounce(() => addPayPalMarketingBanner(true))();
    }
  })
);
const observerConfig = { attributes: true, childList: true, characterData: true, subtree: true };
observer.observe(document.querySelector('.gcc-prd-prcupd-prc-curr'), observerConfig);
